export type RejectionCauseVariant = 'english' | 'native' | 'both'

/**
 * Powód odrzucenia zapisywany jest w formacie "English | Native"
 * (część angielska przed separatorem, natywna po nim). Helper zwraca właściwy
 * wariant zależnie od miejsca użycia:
 *  - 'native'  -> treść w języku odbiorcy,
 *  - 'english' -> treść angielska,
 *  - 'both'    -> obie obok siebie (widok CMS).
 * Wsteczna zgodność: gdy brak separatora, całość traktowana jest jako natywna.
 */
export const getRejectionCause = (
  raw: string | null | undefined,
  variant: RejectionCauseVariant = 'native'
): string => {
  if (!raw) return ''

  const [englishPart, nativePart] = raw.split('|').map(part => part.trim())
  const english = englishPart ?? ''
  const native = nativePart || englishPart || ''

  switch (variant) {
    case 'english':
      return english
    case 'both':
      return english && native && english !== native ? `${english} | ${native}` : native || english
    case 'native':
    default:
      return native
  }
}
